// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hg-navbar-header{width:180px}@media screen and (min-width:768px){.hg-navbar-header{width:240px}}.hg-header.hg-navbar{z-index:50!important;padding-top:0!important}.hg-navbar-container{width:100%;background-color:#fff;min-height:68px;padding:8px}@media (min-width:1024px){.hg-navbar-container{min-height:89px}}.hg-navbar{margin:0 auto;width:100%;max-width:1400px}.hg-navbar-container__border{border-bottom:4px solid #dcfaf5}.hg-deals-heading-nav a{width:100%}", ""]);
// Exports
module.exports = exports;
